import type { Resource } from '../../';
export const cart_cartItem_remove: Resource = {"default":"Remove"};
